import React from "react";
import { motion, cubicBezier } from "framer-motion";

//Data
import { menuData } from "../data/menuData";
import { smashData } from "../data/smashData";

//Default transition
const easing = cubicBezier(0.6, 0.01, -0.05, 0.9);
const transition = { duration: 0.8, ease: easing };

const Offers = (props) => {
  const { setActiveObject, workingHours, getClass } = props;

  const menuOffers = menuData.filter((item) => item.category === "offer");
  const smashOffers = smashData.filter((item) => item.category === "smashOffer");
  const allOffers = [...menuOffers, ...smashOffers];

  return (
    <>
      <ul className="list-menu offer">
        {allOffers.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>
    </>
  );
};

export default Offers;
